import {Grid} from '@mui/material';
import React from 'react';
import SepsisPathwaySelect from './sepsisPathwaySelect';
import {useSepsisFromStyles} from '../useSepsisFromStyles';

const SepsisPathwayFormRow = ({
                                  sepsisField,
                                  sepsisPathwayObj,
                                  canEditSepsis,
                                  setSepsisPathwayField,
                                  setReason,
                                  setReasonRelatedField,
                                  openReason,
                              }) => {
    const classes = useSepsisFromStyles();

    return (
        <div className={classes.sepsisRow}>
            <Grid container alignItems="center" justifyContent="space-between">
                <Grid item xs={10}>
                    {sepsisField.number > 0 &&
                        <Grid container alignItems="stretch">
                            <div className={classes.pathNumber}>
                                {sepsisField.number}
                            </div>

                            <div className={classes.subjectBox}>
                                {sepsisField.subject &&
                                    <div className={classes.subject}>
                                        {sepsisField.subject}
                                    </div>
                                }
                            </div>
                        </Grid>
                    }

                    {(sepsisField.subtitle || sepsisField.description || sepsisField.subDescription) &&
                        <div className={classes.sepsisRowInfoBox}>
                            {sepsisField.subtitle &&
                                <div className={classes.infoBoxRow}>
                                    {sepsisField.subtitle}
                                </div>
                            }

                            {sepsisField.description &&
                                <div className={classes.infoBoxRow}>
                                    {sepsisField.description}
                                </div>
                            }

                            {sepsisField.subDescription &&
                                <div className={classes.infoBoxRow}>
                                    {sepsisField.subDescription}
                                </div>
                            }
                        </div>
                    }
                </Grid>

                <Grid item xs={2}>
                    <SepsisPathwaySelect
                        sepsisField={sepsisField}
                        sepsisPathwayObj={sepsisPathwayObj}
                        canEditSepsis={canEditSepsis}
                        setSepsisPathwayField={setSepsisPathwayField}
                        setReason={setReason}
                        setReasonRelatedField={setReasonRelatedField}
                        openReason={openReason}
                    />
                </Grid>
            </Grid>
        </div>
    );
};

export default SepsisPathwayFormRow;